import { instance, isMock, endpoint, generator } from 'api'
import { mocker } from 'api/hrmsLovCodcomp/mocker'

export default {
  getLovCodcompLabels () {
    if (isMock) return generator(mocker.lovCodcompLabels())
    return instance().get(endpoint + '/hrmsLovCodcomp/getLabels')
  },
  getLovCodcomp (flgNoSecure) {
    if (isMock) return generator(mocker.lovCodcomp())
    let sendParam = {
      flg_no_secure: flgNoSecure ? 'Y' : 'N'
    }
    return instance().get(endpoint + '/hrmsLovCodcomp/getCodcomp', { params: sendParam })
  }
}



// WEBPACK FOOTER //
// ./src/api/hrmsLovCodcomp/index.js